import React from "react";

const PageLoader = () => {
  return (
    <div
      className="
        fixed inset-0 z-[9999]
        flex items-center justify-center
        bg-gradient-to-br
        from-[#f8fbff]
        via-[#eef4ff]
        to-[#f8fbff]
      "
    >
      {/* Soft Glow */}
      <div className="absolute w-52 h-52 rounded-full bg-blue-300/20 blur-[90px]" />

      {/* Loader */}
      <div className="relative flex items-center justify-center">
        {/* Outer Ring */}
        <div className="w-14 h-14 rounded-full border border-blue-100" />

        {/* Animated Gradient Ring */}
        <div
          className="
            absolute
            w-14 h-14
            rounded-full
            border-2
            border-transparent
            border-t-blue-600
            border-r-indigo-500
            animate-spin
          "
        />

        {/* Center Dot */}
        <div
          className="
            absolute
            w-3 h-3
            rounded-full
            bg-gradient-to-r
            from-blue-600
            to-indigo-500
            shadow-[0_0_20px_rgba(59,130,246,0.5)]
            animate-pulse
          "
        />
      </div>
    </div>
  );
};

export default PageLoader;